import { atom } from 'jotai'
import { tickAtom } from './tick.store'
import { timeOffsetAtom } from '../../store/runner.store'

export const currentTimeAtom = atom(Date.now())

const intervalAtom = atom<NodeJS.Timeout | null>(null)

export const clockAtom = atom(
  (get) => get(currentTimeAtom),
  (get, set) => {
    // Clear existing interval if any
    const existingInterval = get(intervalAtom)
    if (existingInterval !== null) {
      clearInterval(existingInterval)
    }

    // Start new interval
    const interval = setInterval(() => {
      set(currentTimeAtom, Date.now())
    }, 500)

    set(intervalAtom, interval)

    // Return cleanup function
    return () => {
      clearInterval(interval)
      set(intervalAtom, null)
    }
  },
)

// Utility atom to get current adjusted time as a function
export const nowAtom = atom((get) => {
  const offset = get(timeOffsetAtom)
  const currentTime = get(currentTimeAtom)
  get(tickAtom)

  return currentTime + offset
})

/**
 * Optimized getter for current clock.
 * Use when clock is needed conditionally.
 */
export const getNowAtom = atom((get) => {
  get(tickAtom)

  return () => get(nowAtom)
})
